import { render, staticRenderFns } from "./StoreProductListTable.vue?vue&type=template&id=6053d342&scoped=true"
import script from "./StoreProductListTable.vue?vue&type=script&lang=js"
export * from "./StoreProductListTable.vue?vue&type=script&lang=js"
import style0 from "./StoreProductListTable.vue?vue&type=style&index=0&id=6053d342&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6053d342",
  null
  
)

export default component.exports